import { Component, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProcessShellService } from '../services/process-shell.service';
import { ResultPageHelper, ResultPageState } from './result-page.helper';


@Component({
  selector: 'app-result-page',
  templateUrl: './result-page.component.html',
  styleUrls: ['./result-page.component.scss'],
  providers: [
    ResultPageHelper
  ]
})
export class ResultPageComponent extends BaseFpxFormComponent<ResultPageHelper, ResultPageState> {

  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private _router: Router,
    public formHelper: ResultPageHelper,
    public _processShellService: ProcessShellService

  ) {
    super(formBuilder, _router, controlContainer, formHelper);
  }
  

}
